<template>
  <div class="partners">
    <modal :title="title" :subtitle="''"
      v-on:close="switchModal"
      v-if="modal">
      <sponsor v-on:close="switchModal" :data="editableSponsor"></sponsor>
    </modal>
    <ccs-header
      :title="'Спонсоры и партнёры'"
      :back="true"/>
    <div class="partners-content">
      <div class="partners-actions">
        <nav-bar :dataFunction="getSponsors" :orderFields="orderFields"/>
        <button v-if="permissionsStatus.isSponsorCreateAllowed"
          class="ccs-button ccs-button--white ccs-button--small" @click="switchModal">
          <img src="@/assets/icons/add.svg" alt="" class="button-icon">
          Добавить спонсора
        </button>
      </div>
      <ccs-table :data="sponsors" :columnsDefs="columnsDefs" :options="tableOptions"
        :defaultActions="defaultActions" @edit="startEditing" @delete="removeSponsor">
        <template #id="{ row }">
          <img v-if="!row.files.data[0]" src="@/assets/images/no_photo.png" :alt="row.name" height="80px"/>
          <img v-else :src="row.files.data[0].url" :alt="row.name" height="80px"/>
        </template>
        <template v-slot:info="props">
          <div class="cell-container">
            <div class="cell-text cell--bold">
              {{ props.row.name }}
            </div>
            <div class="cell-text cell--secondary">
              {{ props.row.email }}
            </div>
            <div class="cell-text">
              {{ props.row.phone || 'Номер отсутствует' }}
            </div>
          </div>
        </template>
        <template v-slot:contact="props">
          <div class="cell-container cell-container--space-evenly">
            <div class="cell-text cell--secondary">
              Контакт
            </div>
            <div class="cell-container"
              v-if="props.row.last_name && props.row.first_name && props.row.patronymic">
              <div class="cell-text cell--bold">
                {{ props.row.last_name }}
              </div>
              <div class="cell-text">
                {{ `${props.row.first_name} ${props.row.patronymic}` }}
              </div>
            </div>
            <div v-else class="cell-container">
              Отсутствует
            </div>
          </div>
        </template>
      </ccs-table>
      <pagination :dataFunction="getSponsors"/>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';

import Header from '@/layouts/Header.vue';
import Table from '@/components/Table.vue';
import Modal from '@/components/Modal.vue';
import NavBar from '@/components/NavBar.vue';
import Pagination from '@/components/Pagination.vue';

import Sponsor from '@/components/modals/sponsors/Sponsor.vue';

export default {
  name: 'Sponsors',
  components: {
    'ccs-header': Header,
    'ccs-table': Table,
    Pagination,
    Modal,
    NavBar,
    Sponsor,
  },
  data() {
    return {
      modal: false,
      titles: {
        new: 'Новый спонсор',
        edit: 'Редактирование спонсора',
      },
      orderFields: [{
        prop: 'id',
        text: 'Дате создания',
      }, {
        prop: 'name',
        text: 'Названию',
      }],
      editableSponsor: null,
      columnsDefs: [{
        name: `id`,
        title: 'ID',
        prop: 'id',
      }, {
        name: `info`,
        title: `Информация`,
        prop: `email`,
      }, {
        name: `contact`,
        title: `Контакт`,
        prop: `name`,
      }],
      tableOptions: {
        hideHeader: true,
      },
    };
  },
  computed: {
    ...mapState('sponsors', ['sponsors']),
    ...mapGetters('session', ['permissionsStatus']),
    title() {
      return this.editableSponsor ? this.titles.edit : this.titles.new;
    },
    defaultActions() {
      return {
        isTitleHidden: true,
        edit: this.permissionsStatus.isSponsorUpdateAllowed,
        delete: this.permissionsStatus.isSponsorDeleteAllowed,
      };
    },
  },
  methods: {
    ...mapActions('sponsors', ['getSponsors', 'updateSponsor', 'deleteSponsor']),
    switchModal() {
      this.modal = !this.modal;
      if (this.editableSponsor) {
        this.editableSponsor = null;
      }
    },
    startEditing(sponsor) {
      this.switchModal();
      this.editableSponsor = Object.assign(sponsor);
    },
    async removeSponsor(sponsor) {
      try {
        await this.deleteSponsor(sponsor.id);
        this.$toasted.success('Спонсор удалён');
      } catch (err) {
        this.$toasted.error(err.message);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.partners {

  &-content {
    margin: 0 33px;
  }

  &-actions {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .ccs-button {
      margin-left: 20px;
    }

  }

  .ccs-table {
    margin-top: 28px;
  }

}
</style>